import { useCallback } from "react";

function useSmoothScroll() {
  const scrollToSection = useCallback((sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = -90; // offset by 90px
      const currentScroll = Math.max(window.pageYOffset || 0, document.body.scrollTop || 0);
      const yPosition = section.getBoundingClientRect().top + currentScroll + yOffset;
      
      window.scrollTo({ top: yPosition, behavior: "smooth" });
      document.body.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  }, []);

  return scrollToSection;
}

export default useSmoothScroll;